import React from "react";

interface props {
    points: number[][];
    size: number;
}

const Solution = (props: props) => {

    console.log(props.points);

    const getClassName = (row: number, col:number) => {


        if (props.points.length === 0) {
            return '';
        }

        if (typeof props.points[row] === 'undefined') {
            return '';
        }

        let className = '';

        props.points[row].forEach((colVal) => {
            if (colVal === col) {
                className = 'active';
                return;
            }
        });

        return className;
    }

    return (<div className="solution">
        {Array.from({ length: props.size }, (_, col) => (
            <div key={col} className="rowVal">
                {Array.from({ length: props.size }, (_, row) => (
                    <div key={row} className="colVal">
                        <span className={getClassName(row, col)}></span>
                    </div>
                ))}
            </div>
        ))}
    </div>);
};

export { Solution };
